module.exports = __webpack_public_path__ + "static/media/thumbnail.333c44f2.jpg";